import { TrustpilotWidget } from '@/components/common/TrustpilotWidget';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import trustpilotBg from '@/assets/trustpilot-bg.png';
const TrustpilotSection = () => {
  const {
    ref,
    isVisible
  } = useScrollAnimation<HTMLElement>();
  return <section ref={ref} className="relative py-24 md:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${trustpilotBg})`
    }} />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4">
        <div className={`grid md:grid-cols-2 gap-8 md:gap-12 items-center transition-all duration-700 ${isVisible ? 'animate-fade-in' : 'opacity-0'}`}>
          {/* Left Column: Text */}
          <div className="text-left space-y-4">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center">
              Trusted by Real Estate Professionals
            </h2>
            <p className="text-lg md:text-xl text-white/90 text-center">
              Join thousands of investors and wholesalers who trust GoDyspo for their real estate deals.
            </p>
          </div>
          
          {/* Right Column: Widget */}
          <div className="flex items-center justify-center md:justify-end">
            <div className="w-full max-w-md">
              <TrustpilotWidget />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default TrustpilotSection;